import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { LogService } from '../logs/log.service';
import { HALResponse } from '../shared/model/app.model';
import { Report, ReportOutputType } from './report.model';
import { GeneralParameters } from "app/shared/model/request-parameter.model";
import { PagedEntity } from "app/shared/model/app.model";

@Injectable({
	providedIn: 'root'
})
export class ReportService {
	enterNotesFilterReportId: number | null | undefined;

	private reportOutputTypes$?: Observable<ReportOutputType[]>;

	constructor(
		private http: HttpClient
	) {
		LogService.selectedLog$.subscribe(() => this.enterNotesFilterReportId = undefined);
	}

	getOutputTypes() {
		if (!this.reportOutputTypes$) {
			this.reportOutputTypes$ = this.http.get<HALResponse<{ reportOutputTypes: ReportOutputType[] }>>(
				'/api/reportOutputTypes'
			)
			.pipe(
				map(r => r._embedded.reportOutputTypes),	
				shareReplay(1)
			);
		}

		return this.reportOutputTypes$;
	}
	
	fetch(query: GeneralParameters) {
		return this.http.get<HALResponse<{ reports: Report[] }>>('/api/reports', { params: query })
			.pipe(map(res => PagedEntity.from(res._embedded.reports, res.page)));
	}
	
	deleteReport(report: Report) {
		return this.http.delete(report._links.self.href);
	}
	
	patchReport(report: Report, update: any) {
		return this.http.patch(report._links.self.href, update);
	}
}